// extracted by mini-css-extract-plugin
module.exports = {"root":"modal_root__J7_P_","form":"modal_form__R65wV","container":"modal_container__tQj6N"};